import { useEffect, useState } from 'react';
import { getMarketReport } from 'api/marketing';
import { IAdMetrics, IAdMetricsDisplay } from 'types/marketing';
import { convertAdMetricsToDisplay } from 'utils/marketing';

interface MarketingReport {
    report: {
        lastTwoWeekPerformanceLevel: 'LOW' | 'MID' | 'TOP';
    },
    summary: IAdMetrics;
}

interface MarketingReportDisplay {
    report: {
        lastTwoWeekPerformanceLevel: 'LOW' | 'MID' | 'TOP';
    },
    summary: IAdMetricsDisplay;
}

const useMarketingReport = (): [MarketingReportDisplay | undefined, boolean, () => void] => {
    const [loading, setLoading] = useState(false);
    const [report, setReport] = useState<MarketingReportDisplay>();

    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await getMarketReport();
            if (!result.error) {
                const reportRes: MarketingReport = result.data.data;
                setReport({
                    report: {
                        lastTwoWeekPerformanceLevel: reportRes.report.lastTwoWeekPerformanceLevel,
                    },
                    summary: convertAdMetricsToDisplay(reportRes.summary, 2),
                });
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchData();
    }, []);

    return [report, loading, fetchData];
};

export default useMarketingReport;
